export default __webpack_public_path__ + "static/media/next-page.23e49fa0.svg";